// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		loadProductFirst: true,
		numberFilterTree: 3,
		filterTreeMobileStyle: 'style3',
    showLimitList: '12,24,48,70'
	},
  selector: {
  trackingQuickView: '.quick_shop'
}
};

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		stickerValue = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		let stickertagValue = data.tags.filter(tag => tag.includes('e-sticker:'));
		stickerValue = stickertagValue.length ? stickertagValue : false;
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add sticker
		itemHtml = itemHtml.replace(/{{itemSticker}}/g, buildsticker());
		// Add Custom Sticker Label
		itemHtml = itemHtml.replace(/{{itemAddLabels}}/g, buildAddLabels(data));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		// Add Instore Only
		itemHtml = itemHtml.replace(/{{itemInstoreOnly}}/g, builditemInstoreOnly(data));
		// Add product form
		itemHtml = itemHtml.replace(/{{itemAddToCartForm}}/g, buildForm(data));
		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};

  // Build Product List Item
  ProductListItem.prototype.compileTemplate = function(data, index, totalProduct) {
    if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

    // Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add sticker
		itemHtml = itemHtml.replace(/{{itemSticker}}/g, buildsticker());
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		// Add Instore Only
		itemHtml = itemHtml.replace(/{{itemInstoreOnly}}/g, builditemInstoreOnly(data));
		// Add product form
		itemHtml = itemHtml.replace(/{{itemAddToCartForm}}/g, buildForm(data));
		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
  }

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildImages(data) {
		var html = '',
			rangeWidths = boostPFSRangeWidths;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 && boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		// CAUTION - Any edits here must also be done on product-card.liquid
		if (images.length > 0) {
			html += '<div class="product-card__image-wrapper relative w-full rounded-lg overflow-hidden';
			if (boostPFSThemeConfig.custom.show_secondary_image == true) {
				html +=	' hover-effect';
			}
			if (boostPFSThemeConfig.custom.image_ratio==='square' ) {
				html +=	' aspect-w-1 aspect-h-1';
			} else {
				html +=	' aspect-w-8 aspect-h-12';
			}
			html +=	'">';

			html += '<img class="product-card__image w-full h-full object-center transition-all duration-300';
			if (boostPFSThemeConfig.custom.image_ratio === 'square' ) {
				html +=	' object-contain';
			} else {
				html +=	' object-contain';
			}
			html +='" loading="lazy"' +
				'srcset="' + dataSrcSet + '" ' +
				'height="' + images[0].height + '" ' +
				'width="' + images[0].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';

			if (activeSwapImage) {
				html += '<img class="product-card__image w-full h-full object-center transition-all duration-300';
				if (boostPFSThemeConfig.custom.image_ratio === 'square' ) {
					html +=	' object-cover';
				} else {
					html +=	' object-contain';
				}
				html +='" loading="lazy"' +
					'srcset="' + flipImageSrcSet + '" ' +
					'height="' + images[1].height + '" ' +
					'width="' + images[1].width + '" ' +
					'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
					'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
					'alt="' + imgAlt + '" />';
			}

			html += '</div>';
		} else {
			html += '<div class="card__content"><h2 class="card__text h2">' + data.title  + '</h2></div>'
		}
		return html;
	}
	function builditemInstoreOnly(data) {
		var html = '';
		let tags = data.tags;
		instoreOnlyTag = tags.find(element => element == "e-instore-only: Yes");
		if(instoreOnlyTag){
			html = '<p class="product-card__instore_only font-light mx-5 text-xs">Instore Only</p>';
		}
		else {
			html = '<p class="product-card__instore_only placeholder font-light mx-5 text-xs"></p>';
		}
		return html;
	}
	function buildForm(data) {
		let html = boostPFSTemplate.productFormHtml;
		let addToCartFormClass = "";
		let viewProductClass = "";
		let variantSelect = "";
		let addToCartBtnClass = "";
		let qtyClass = "";
		let showForm = false;
		let showFormClass = "";
		let showFormBtn = "";
		let submitBtnDisabledAtt = "";
		html = html.replace(/{{itemId}}/g, data.id);
		
		if (instoreOnlyTag) {
			addToCartFormClass = "hidden";
		} else if (data.available == false && data.variants.length == 1) {
			addToCartFormClass = "hidden";
		} else if (data.variants.length == 1 ) {
			variantSelect = '<input type="hidden" name="id" value="' + data.variants[0].id + '" class="original-selector">';
			viewProductClass = "hidden";
		} else if (data.variants.length > 1) {
			if (data.available == false) {
				addToCartBtnClass = "hidden";
				addToCartFormClass = "hidden";
			}else {
				viewProductClass = "hidden";
				showForm = true;
				submitBtnDisabledAtt = "disabled";
			}

			let optionsHeading = "";
			if (data.options.length > 0) {
				let optionsTitle = "";
				data.options.forEach(option => {
					optionsTitle = optionsTitle + ' & ' + option;
				})
				optionsHeading = '<p class="product-card--options--title">CHOOSE' + optionsTitle.replace("&", "") +'</p>';
			}
			

			if (data.options.length > 1) {
				let variantOptions = "";
				
				let optionName = "";
				data.variants.forEach(variant => {
					let optionAttr = "";
					data.options.forEach((option, index) => {
						optionName = data.variants;
						optionAttr = optionAttr + ' data-option--' + option + '="' + variant.options[index] + '"';
					})
					let option = '<option value="' + variant.id + '"' +
									(variant.available ? "" : ' disabled ') +
									optionAttr +
								'>'+
								variant.title +
								'</option>';
								
					variantOptions = variantOptions + option;

					
				});
				let variantSelectMain = '<select data-product-id="' + data.handle + '" name="id" class=" product-card--option-select product-card--option-'+ optionName +' product-card--variants-select">' +
										variantOptions +
									'</select>';
				
				let selects = "";
				data.options_with_values.forEach((option, index) => {
					let optionVariants = "";
					option.values.forEach(value => {
						optionVariants = optionVariants + '<option data-image-position="' + value.image + '"' + (index != 0 ? " disabled" : "") +'>' + value.title + '</option>';
					});

					let select = '<div class="product-card--option">' +
					            	'<div class="product-card--option-dropdown">' +
										'<select data-product-id="' + data.handle + '" id="' + data.id +'--option-' + option.name +'" name="options[' + option.name +']" data-option-title="' + option.name +'"  class="product-card--option-select product-card--option-'+ option.name +' outline-none appearance-none">' +
											'<option selected disabled hidden>' + option.name +'</option>' +
											optionVariants +
										'</select>' +
										'<div class="open-select"></div>' +
									'</div>' +
								'</div>';
					selects = selects + select;

				});
				let optionSelect = '<div class="product-card--options">' + selects + '</div>';
				variantSelect = optionsHeading + variantSelectMain + optionSelect;
				
			} else if (data.options.length == 1) {
				let options = "";
				data.variants.forEach(variant => {
					let optionHtml = '<option data-image-position="' + variant.image + '" value="' + variant.id + '" ' + (variant.available ? "" : 'disabled') + '>' + variant.title + '</option>';
					options = options + optionHtml;
				})
				let wrapper = '<div class="product-card--options"><div class="product-card--option">' +
					'<div class="product-card--option-dropdown">' +
						'<select data-product-id="' + data.handle + '" id="' + data.id +'--option-' + data.options[0].toLowerCase() +'" name="id" class="product-card--option-select product-card--option-' + data.options[0].toLowerCase() + ' outline-none appearance-none">'+
							options +
						'</select>' +
						'<div class="open-select"></div>' +
					'</div>' +
				'</div></div>';
				variantSelect = optionsHeading + wrapper;
				submitBtnDisabledAtt = "";
			}

		}

		if (showForm) {
			showFormClass = "product-form--modal hidden";
			showFormBtn = '<p class="add-to-cart-button js-trigger-product-form">Add to cart</p>';
		}

		html = html.replace(/{{itemFirstVariantId}}/g, variantSelect);
		html = html.replace(/{{addToCartFormClass}}/g, addToCartFormClass);
		html = html.replace(/{{viewProductClass}}/g, viewProductClass);
		html = html.replace(/{{addToCartBtnClass}}/g, addToCartBtnClass);
		html = html.replace(/{{qtyClass}}/g, qtyClass);
		html = html.replace(/{{variantSelect}}/g, variantSelect);
		html = html.replace(/{{showFormClass}}/g, showFormClass);
		html = html.replace(/{{showFormBtn}}/g, showFormBtn);
		html = html.replace(/{{submitBtnDisabledAtt}}/g, submitBtnDisabledAtt);
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else {
      html = 'card--outline';
    }
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') && boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(data.price_min))
			: Utils.formatMoney(data.price_min);
		var regularPrice = data.price_min;
		var salePrice = data.compare_at_price_min;
		var onSaleClass = data.price_min < data.compare_at_price_min ? "" : "hidden";
		var regularClass = data.price_min < data.compare_at_price_min ? "hidden" : " ";
		// Replacing old syntax, as ?. optional chaining not supported in Safari 12
		// var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		var unitPriceClass;
		let variantCheck;
		variantCheck = data.selected_or_first_available_variant;
		if (!data.available) {
			unitPriceClass = 'hidden';
		}
		else if (variantCheck === null || variantCheck === undefined) {
			unitPriceClass = 'hidden';
		}
		else if (variantCheck.unit_price_measurement === null || variantCheck.unit_price_measurement === undefined) {
			unitPriceClass = 'hidden';
		}
		else if (variantCheck.unit_price_measurement !== null && variantCheck.unit_price_measurement !== undefined) {
			unitPriceClass = '';
		}
		// END of replacement

		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
					<dl>
						<div class="price__regular ${regularClass} justify-start">
							<dd>
								<span class="mt-2 price-item price-item--regular font-black text-lg">
									${moneyPrice}
						  		</span>
							</dd>
						</div>
						<div class="price__sale ${onSaleClass} flex justify-start">
							<dd class="price__last">
								<span class="mt-2 price-item price-item--sale font-black text-lg">
									${moneyPrice}
								</span>
						  	</dd>
							<dd class="price__compare price__compare-price">
								<s class="mt-2 price-item price-item--regular font-black text-lg">
								${Utils.formatMoney(data.compare_at_price_min)}
								</s>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut && !stickerValue) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut && !stickerValue) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}

	function buildsticker() {
		// Build Sale label
		var sticker = '';
		if (stickerValue) {
			let stickerArr = stickerValue[0].replace('e-sticker:','').split(":");
			sticker = boostPFSTemplate.stickerHtml.replace(/{{stickerColor}}/g, stickerArr[0]).replace(/{{stickerText}}/g, stickerArr[1]);
		}
		return sticker;
	}

	// Labelling component (from our Shopify-UI-library) - Find docs in docs/label-component.md
	function buildAddLabels(data) {
		let addLabelHtmls = "";
		let sticker_tags = data.tags.filter(tag => tag.toLowerCase().includes('sticker') && !(tag.toLowerCase().includes('e-sticker')));
		let e_sticker_tags = data.tags.filter(tag => tag.includes('e-sticker:'));

		if ( (sticker_tags.length > 0 && e_sticker_tags.length == 0) || ((data.tags.includes('Collect in store only') || data.tags.includes('e-collection-only: Yes')) && window.settings.ciso_text) ) {
		  let stickersHtml = '';
		  sticker_tags.forEach( sticker => {
			let sticker_variables = sticker.split(":");
			let sticker_text = sticker_variables[sticker_variables.length - 1];
			let sticker_shape = "rectangle", sticker_color = "#77C19A";

			sticker_variables.forEach((element, index) => {
				if (index === 0 || element.includes('sticker')) return;
				if (index === sticker_variables.length - 1) return;
				if (element.includes('rectangle') || element.includes('circular')) {
					sticker_shape = element;
				} else {
					sticker_color = element;
				}
			  });
	
			let stickerHTML = boostPFSTemplate.customStickerHtml.replace(/{{stickerColor}}/g, sticker_color );
			stickerHTML = stickerHTML.replace(/{{stickerText}}/g, sticker_text );
			stickerHTML = stickerHTML.replace(/{{stickerShape}}/g, sticker_shape );
			
			stickersHtml += stickerHTML;
		  })
		  if((data.tags.includes('Collect in store only') || data.tags.includes('e-collection-only: Yes')) && window.settings.ciso_text) {
			let stickerHTML = boostPFSTemplate.customStickerHtml.replace(/{{stickerColor}}/g, '#F9C20A');
			stickerHTML = stickerHTML.replace(/{{stickerText}}/g, window.settings.ciso_text);
			stickerHTML = stickerHTML.replace(/{{stickerShape}}/g, 'rectangle');

			stickersHtml += stickerHTML;
		  }
		  addLabelHtmls += boostPFSTemplate.addLabelsHtml.replace(/{{addLabels}}/g, stickersHtml );
		}

		
		return addLabelHtmls;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousWrapClass = (currentPage == 1) ? "disabled" : '';
		var previousHtml = boostPFSTemplate.previousActiveHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		previousHtml = previousHtml.replace(/{{itemWrapClass}}/g, previousWrapClass);
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextWrapClass = (currentPage == totalPage) ? "disabled" : '';
		var nextHtml = boostPFSTemplate.nextActiveHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		nextHtml = nextHtml.replace(/{{itemWrapClass}}/g, nextWrapClass);
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'selected="selected"'
					}
					sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		let sorting_option = jQ('.collection-filters__sort').val();
		if(sorting_option.length > 13){
			jQ('.boost-pfs-filter-top-sorting').addClass('hide-sort-title-end');
		}else{
			jQ('.boost-pfs-filter-top-sorting').removeClass('hide-sort-title-end');
		}
		jQ('.collection-filters__sort').change(function(e) {
			e.preventDefault();
			sorting_option = jQ(this).val();
			if(sorting_option.length > 13){
				jQ('.boost-pfs-filter-top-sorting').addClass('hide-sort-title-end');
			}else{
				jQ('.boost-pfs-filter-top-sorting').removeClass('hide-sort-title-end');
			}
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};

  //Build Display type
  ProductDisplayType.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('displayTypeHtml')) {
      var itemHtml = '';
      if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text">Grid</span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text">List</span></a>';
      } else {
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text">Grid</span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text">List</span></a>';
      }

      itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);
      html = boostPFSTemplate.displayTypeHtml.replace(/{{displayTypeItems}}/g, itemHtml);
    }
    return html;
  };

  // Build Show Limit
  ProductLimit.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

      var numberList = Settings.getSettingValue('general.showLimitList');
      if (numberList != '') {
        // Build content
        var showLimitItemsHtml = '';
        var arr = numberList.split(',');
        for (var k in arr) {
          showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
        }
        html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      }
    }
    return html;
  };

  // Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		Shopify.theme.productVariants.listen();
		Shopify.theme.productVariants.displayCard();
		Shopify.theme.productVariants.showForm();
		Shopify.theme.jsAddToCart.listen();
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
		// SF9 - To hide liquid layout until JS layout is loaded
		document.dispatchEvent(new Event('e_bpfs-loaded'));

		const selectBox = document.querySelectorAll('.product-card--option-colour');
		selectBox.forEach((box) => {
			box.addEventListener('change', function() {
				// This function will be called when the select box changes
				const productHandle = box.getAttribute('data-product-id');
				const selectedOption = box.options[box.selectedIndex];

				// Get the value of the 'selected' attribute (or any other attribute)
				let imagePosition = selectedOption.getAttribute('data-image-position');

				if(imagePosition !== null && imagePosition !== undefined && imagePosition !== 'null' && !isNaN(imagePosition) && !imagePosition.includes('https://cdn.shopify.com')) {
					imagePosition = imagePosition - 1;
				}

				fecthProduct(productHandle, imagePosition, box);
			});	
		});

		function fecthProduct(item, imagePosition, evt) {
			var xhr = new XMLHttpRequest();
			xhr.onreadystatechange = function() {
			  if (xhr.readyState === 4 && xhr.status === 200) {
				// Parse the JSON response
				var product = JSON.parse(xhr.responseText);
				let imageSrc = '';
				imagePosition = imagePosition.toString();			
				if(imagePosition.includes('https://cdn.shopify.com')) {
					imageSrc = imagePosition;
				} else {
					imageSrc = product.images[imagePosition];
				}

				if(imagePosition !== null || imagePosition !== undefined || imagePosition !== 'null' || !isNaN(imagePosition)) {
					changeProductImage(imageSrc, evt);
				}
			  }
			};
			// Specify the request method and URL
			xhr.open('GET', '/products/' + item + '.js', true);
			// Send the request
			xhr.send();
		}

		function changeProductImage(imageSrc, evt) {
			const productCard = evt.closest('.product-card');
			const image = productCard.querySelector('.product-card__image');
			let cleanedSrc = '';
			let fileExtension = '';
			if(typeof imageSrc !== "undefined") {
				if(imageSrc.includes('.jpg')) {
					fileExtension = '.jpg';
					cleanedSrc = imageSrc.split('.jpg');
				} else if(imageSrc.includes('.png')) {
					fileExtension = '.png';
					cleanedSrc = imageSrc.split('.png');
				} else {
					cleanedSrc = '';
				}
			}
			
			let srcset = cleanedSrc[0] + '_165x' + fileExtension + ' 165w, ' + cleanedSrc[0] + '_360x' + fileExtension + ' 360w, ' + cleanedSrc[0] + '_533x'  + fileExtension + ' 533w,' + cleanedSrc[0] + '_720x'  + fileExtension +  ' 720w, ' + cleanedSrc[0] + '_940x' + fileExtension + ' 940w,' + cleanedSrc[0] + '_1066x' + fileExtension + ' 1066w';
			image.src = imageSrc;
			image.srcset = srcset;
		}

		let stickyFilters;

		if (window.innerWidth <= 768) {
			stickyFilters = document.querySelector('.filters-sticky-mobile');
		} else {
			stickyFilters = document.querySelector('.sidebar-sticky');
		}

		if (stickyFilters) {
			let lastPosition = window.scrollY;
			document.addEventListener("scroll", (event) => {
				if (lastPosition > window.scrollY) {
					stickyFilters.classList.add('sticky');
				} else {
					stickyFilters.classList.remove('sticky');
				}
				lastPosition = window.scrollY;

			});
		}
	};

	/************************** END BUILD TOOLBAR **************************/
})();